import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from '@progress/kendo-intl';
import { AllianceVehicleValue } from '../Vehicles';

export default function allianceCarrierScore(openReviews: (data: AllianceVehicleValue) => void) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      if (!this.props.field) return null;

      return (
        <td {...this.props.tdProps} style={{ cursor: "pointer", textAlign: "right" }} onClick={() => openReviews(this.props.dataItem)}>
          {this.props.dataItem.CarrierScore != null ? formatNumber(this.props.dataItem.CarrierScore, "n0") : ""}
        </td>
      );
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
      return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
    }
  }
}
